import { useBootup } from '@/hooks/useBootup';
import { resolveComponentizationEligibleSkus } from '@/constants/componentizationSkus';

/**
 * SKUs eligible for componentized flows. Prefer getInit
 * `componentizationEligibleSkus` (v1/v2); fall back to the local allowlist.
 */
export const useComponentizationEligibleSkus = (): string[] => {
  const { bootupState } = useBootup();
  return resolveComponentizationEligibleSkus(
    bootupState?.componentizationEligibleSkus,
  );
};
